import type { ContentTypeType } from '@confluence/editor-features/entry-points/ContentTypeType.ts';

export const onClickPageRevert = (
	push: any,
	contentType: ContentTypeType | null,
	spaceKey: string,
	contentId?: string,
	contentStatus?: string,
): void => {
	if (!contentType || !contentId) {
		return;
	}
	const isBlogPost = contentType === 'blogpost';
	const isCreate = contentStatus === 'draft';

	if (isBlogPost && !isCreate) {
		push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
	} else if (!isCreate) {
		push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
	} else {
		push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
	}
};
